import { classNames } from "../../../../utils/classNames"
import { SelectItemType } from "../Select"

type Props = {
    isActive: boolean
    item: SelectItemType
    onClick: (id: string) => void
    disabled?: boolean
}

export const SelectItem = (props: Props) => {
    return (
        <button
            type="button"
            role="option"
            aria-selected={props.isActive}
            disabled={props.disabled}
            className={classNames(classes.button, props.isActive && classes.active, props.disabled && classes.disabled)}
            onClick={() => {
                props.onClick(props.item.id)
            }}>
            {props.item.label}
        </button>
    )
}

const classes = {
    button: "align-left relative flex w-full cursor-pointer items-center truncate bg-white h-[2.1rem] pl-3 hover:bg-[#E0F6E1] hover:bg-opacity-50 focus:outline-none",
    active: "font-bold bg-[#E0F6E1] bg-opacity-50",
    disabled: "opacity-50",
}
